import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeSigninRedirect } from './AuthProvider';

export function CallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let abandoned = false;

    completeSigninRedirect()
      .then(signedInUser => {
        if (abandoned) return;
        const returnUrl = (signedInUser.state as { returnUrl?: string } | undefined)?.returnUrl;
        navigate(returnUrl ?? '/', { replace: true });
      })
      .catch(error => {
        if (abandoned) return;
        console.error('Signin callback error:', error);
        navigate('/login', { replace: true });
      });

    return () => {
      abandoned = true;
    };
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
}
